'use client'

import { FC } from 'react'

import { Panel, PanelItem, PanelLayout } from '../../Panel'
import styles from './styles.module.scss'
import cx from 'classnames'

import { Colour, SectionPaddingDefault } from '../../constants'
import { CmsPageSectionBase, CmsResponsiveImage } from '../../ComposedPage'
import { HeroCtas } from '../PageHero/HeroCtas'
import { AppStoreButtons } from '../../AppStoreButtons'
import { ImageFit } from '../../CardPanel/CardPanelTypes'
import { DynamicImage } from '@/components/DynamicImage'
import { getAssetUrl } from '@/utils/contentfulAsset'

export interface CmsPaddedPageBannerSection extends CmsPageSectionBase {
  fields: CmsPageSectionBase['fields'] & {
    title?: string
    subtitle?: string
    bodyCopy?: string
    listItems?: string[]
    primaryCtaUrl?: string
    primaryCtaText?: string
    secondaryCtaUrl?: string
    secondaryCtaText?: string
    showOpenAccountButton?: boolean
    iosQuickLink?: string
    testIosQuickLink?: string
    androidQuickLink?: string
    testAndroidQuickLink?: string
    image?: CmsResponsiveImage
    backgroundColour: Colour
  }
}

export const PaddedPageBanner: FC<CmsPaddedPageBannerSection> = ({
  fields,
}) => {
  const {
    title,
    subtitle,
    bodyCopy,
    listItems,
    primaryCtaUrl,
    primaryCtaText,
    secondaryCtaUrl,
    secondaryCtaText,
    showOpenAccountButton,
    iosQuickLink,
    testIosQuickLink,
    androidQuickLink,
    testAndroidQuickLink,
    image,
    sectionPaddingTop,
    sectionPaddingBottom,
    backgroundColour = Colour.warmStone,
  } = fields
  return (
    <Panel
      className={styles.paddedPageBanner}
      short
      colour={Colour.warmStone}
      layout={PanelLayout.full}
    >
      <PanelItem
        className={cx(
          styles.bannerItem,
          styles[sectionPaddingTop || SectionPaddingDefault.TOP],
          styles[sectionPaddingBottom || SectionPaddingDefault.BOTTOM],
        )}
      >
        <div className={styles.content}>
          <div className={cx(styles.copyContainer, styles[backgroundColour])}>
            <div className={styles.copy}>
              {title && <h4>{title}</h4>}
              {subtitle && <h5>{subtitle}</h5>}
              {bodyCopy && <p>{bodyCopy}</p>}
              {listItems?.length && (
                <ul>
                  {listItems.map(item => {
                    return <li key={item}>{item}</li>
                  })}
                </ul>
              )}
              <HeroCtas
                className={styles.ctaContainer}
                showOpenAccountButton={showOpenAccountButton}
                primaryCtaUrl={primaryCtaUrl}
                primaryCtaText={primaryCtaText}
                secondaryCtaUrl={secondaryCtaUrl}
                secondaryCtaText={secondaryCtaText}
                backgroundColour={backgroundColour}
              />
              <AppStoreButtons
                className={cx(styles.appStoreButtons, styles.ctaContainer)}
                testIosQuickLink={testIosQuickLink}
                testAndroidQuickLink={testAndroidQuickLink}
                iosQuickLink={iosQuickLink}
                androidQuickLink={androidQuickLink}
              />
            </div>
          </div>
        </div>
      </PanelItem>

      {image && getAssetUrl(image) && (
        <div className={styles.backgroundImage}>
          <DynamicImage
            image={image}
            alt=""
            fill
            style={{
              objectFit: ImageFit.COVER,
            }}
            sizes="(min-width: 1920px) 1920px, 100vw"
          />
        </div>
      )}
    </Panel>
  )
}
